import {
  SupplierContractCheckItemRequest,
  SupplierContractCheckItemResponse,
  SupplierContractCheckResponse,
} from '../../../../core/clients/omni-core/models';

export interface SupplierContractCheckFormModel {
  CHECK_CONSUMPTION_FLEXIBILITY: SupplierContractCheckItemRequest;
  CHECK_CONTRACT_FLEXIBILITY: SupplierContractCheckItemRequest;
  CHECK_DECISION_MAKING_EFFORT: SupplierContractCheckItemRequest;
  CHECK_FIX_COST: SupplierContractCheckItemRequest;
  CHECK_FIX_PRICE_GUARANTEE: SupplierContractCheckItemRequest;
  CHECK_INDEX_PRICE_DEPENDENCY: SupplierContractCheckItemRequest;
  CHECK_MARGIN_TRANSPARENCY: SupplierContractCheckItemRequest;
  CHECK_OVERALL_COST: SupplierContractCheckItemRequest;
  CHECK_PRICE_CONSUMPTION_MATCH: SupplierContractCheckItemRequest;
  CHECK_PRICING_BILLING_COMPLEXITY: SupplierContractCheckItemRequest;
  CHECK_TRANCHE_TIMING_PERFORMANCE: SupplierContractCheckItemRequest;
}

const toCheck = (check: SupplierContractCheckItemResponse): SupplierContractCheckItemRequest => ({
  result: check.result,
  documentId: check.documentId,
  explanation: check.explanation,
});

export const toModel = (data: SupplierContractCheckResponse): SupplierContractCheckFormModel => {
  return {
    CHECK_CONSUMPTION_FLEXIBILITY: toCheck(data.CHECK_CONSUMPTION_FLEXIBILITY),
    CHECK_CONTRACT_FLEXIBILITY: toCheck(data.CHECK_CONTRACT_FLEXIBILITY),
    CHECK_DECISION_MAKING_EFFORT: toCheck(data.CHECK_DECISION_MAKING_EFFORT),
    CHECK_FIX_COST: toCheck(data.CHECK_FIX_COST),
    CHECK_FIX_PRICE_GUARANTEE: toCheck(data.CHECK_FIX_PRICE_GUARANTEE),
    CHECK_INDEX_PRICE_DEPENDENCY: toCheck(data.CHECK_INDEX_PRICE_DEPENDENCY),
    CHECK_MARGIN_TRANSPARENCY: toCheck(data.CHECK_MARGIN_TRANSPARENCY),
    CHECK_OVERALL_COST: toCheck(data.CHECK_OVERALL_COST),
    CHECK_PRICE_CONSUMPTION_MATCH: toCheck(data.CHECK_PRICE_CONSUMPTION_MATCH),
    CHECK_PRICING_BILLING_COMPLEXITY: toCheck(data.CHECK_PRICING_BILLING_COMPLEXITY),
    CHECK_TRANCHE_TIMING_PERFORMANCE: toCheck(data.CHECK_TRANCHE_TIMING_PERFORMANCE),
  };
};
